module.exports = __webpack_public_path__ + "static/media/cta-image.48fb5bf6.jpg";